import { render, staticRenderFns } from "./MessageSuccess.vue?vue&type=template&id=5265ba58&"
import script from "./MessageSuccess.vue?vue&type=script&lang=js&"
export * from "./MessageSuccess.vue?vue&type=script&lang=js&"
import style0 from "./MessageSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports